import { Breakpoint } from '~hooks/use-current-breakpoint';

import { ResponsiveProp } from '../app-typography';

const breakpointsOrder: Breakpoint[] = ['xs', 'sm', 'md', 'lg', 'xl'];

export const getCascadeBreakpointValue = <T>(
  prop: ResponsiveProp<T> | undefined,
  current: Breakpoint,
  order: Breakpoint[] = breakpointsOrder
): T | undefined => {
  if (!prop) return undefined;

  const currentIndex = order.indexOf(current);
  for (let i = currentIndex; i >= 0; i--) {
    const bp = order[i];
    if (prop[bp] !== undefined) return prop[bp];
  }

  return undefined;
};
